<template>
    <div class="flex flex-wrap items-center justify-center mb-6">
        <div class="w-full">
            <div class="sm:flex sm:inline-flex justify-between mb-3">
                <h3 class="align-middle font-bold mr-4 mb-0">
                    <a :href="'/c/' + category.id + '-' + category.slug">{{ category.name }}</a>
                </h3>

                <a :href="'/c/' + category.id + '-' + category.slug" class="btn btn-secondary border-2 rounded-full font-semibold">
                    View {{ category.name }}
                </a>
            </div>

            <div class="mb-3">
                <listing-grid :categoryId="category.id" :limit="4" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['category'],

    data: () => ({}),

    created() {},

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
